/* NEWBORN */
export const PERMISSION_ADD_NEWBORN = 'add newborn';
export const PERMISSION_DELETE_NEWBORN = 'delete newborn';
